module.exports = __webpack_public_path__ + "static/roid1_word-9e9839745b315dfdc22efbd936828a95.png";